import axios, { AxiosResponse } from "axios";
import { API } from "../index";
import { getRefreshToken, getDeviceId, getDeviceName } from "../auth";

const devicePayload = () => ({
  device_id: getDeviceId(),
  device_name: getDeviceName(),
  client_source: "web",
});
import { REDIRECT_URI } from "../../common/social/kakao/api";

export const authService = {
  postPhoneAuth: async (phoneNum: string): Promise<AxiosResponse> => {
    return await API.post(`/auth/`, { phone_num: phoneNum });
  },

  // 보안: 인증번호는 서버가 확인한다(응답으로 받지 않음)
  postPhoneLogin: async (phoneNum: string, authNum?: string): Promise<AxiosResponse> => {
    return await API.post(`/api/token/`, { phone_num: phoneNum, auth_num: authNum, ...devicePayload() });
  },

  postKakaoToken: async (kakaoToken: string, channel_id: string | undefined = undefined ): Promise<AxiosResponse> => {
    return await API.post(`/api/token/`, { kakao_token: kakaoToken, channel_id, ...devicePayload() });
  },

  // 결정 87(2026-10-15): 인가 코드 교환을 백엔드에서 한다(REST 키·Client Secret을 브라우저가 쓰지 않음).
  // restApiKey 인자는 호출부 호환용으로 남겨 두고 쓰지 않는다.
  exchangeKakaoCode: async (code: string, _restApiKey?: string): Promise<AxiosResponse> => {
    return await API.post(`/api/v2/auth/kakao-exchange`, { code, redirect_uri: REDIRECT_URI });
  },

  completeKakaoLogin: async (kakaoToken: string, phoneNumber: string): Promise<AxiosResponse> => {
    return await API.post(`/api/v2/auth/complete-kakao`, {
      kakao_access_token: kakaoToken,
      phone_number: phoneNumber,
      ...devicePayload(),
    });
  },

  unlinkKakaoAccount: async (): Promise<AxiosResponse> => {
    return await axios.post(`https://kapi.kakao.com/v1/user/unlink`, {}, {
      headers: {
        baseURL: ''
      }
    });
  },

  adminLogin: async (phone_num: string, password: string): Promise<AxiosResponse> => {
    return await API.post("/api/token/admin/", { phone_num, password, ...devicePayload() });
  },

  refreshToken: () => {
    return API.post('/api/token/refresh/', {
      refresh_token: getRefreshToken(),
      ...devicePayload(),
    });
  },

  getSessions: async (): Promise<AxiosResponse> => {
    return await API.get("/api/v2/auth/sessions");
  },

  revokeSession: async (sessionId: string): Promise<AxiosResponse> => {
    return await API.delete(`/api/v2/auth/sessions/${sessionId}`);
  }
};

export const changeCancelableUserConfirm = async (isConfirm: boolean) => {
  return API.put('/sites/cancelable-user-confirm/', {
    confirm: isConfirm,
    read: true
  });
};

export const changeCancelableUserRead = async () => {
  return API.put('/sites/cancelable-user-confirm/', {
    confirm: false,
    read: true
  });
};
